import { Button, Spin } from "antd";
import { useEffect, useState } from "react";
import React from "react";

import down2 from "../../../assets/icons/Polygon 2.png";
import up2 from "../../../assets/icons/Polygon 1.png";

export default function Priority({ loading, initialPriority, onUpdate, record, disabled }) {
  const [count, setCount] = useState(Number(initialPriority));

  const increasePriority = async () => {
    const newPriority = Number(count) + 1;
    setCount(newPriority);
    onUpdate(newPriority, record);
  };

  const decreasePriority = async () => {
    const newPriority = Math.max(Number(count) - 1, 0);
    setCount(newPriority);
    onUpdate(newPriority, record);
  };

  useEffect(() => {
    setCount(initialPriority);
  }, [initialPriority]);

  return (
    <div className={`div-prority ${disabled && "div-priority-disable"}`}>
      <Button type="text" icon={<img src={down2} alt="" />} onClick={decreasePriority} loading={loading} disabled={disabled} />
      {loading ? <Spin size="small" /> : <p className="p-fontSize"> {count} </p>}
      <Button type="text" icon={<img src={up2} alt="" />} onClick={increasePriority} loading={loading} disabled={disabled} />
    </div>
  );
}
